import styled from 'styled-components'
import { Button } from '@sketch/components'

export const DescriptionText = styled.div`
  min-width: 0;
  flex: 1;
`

export const EditButton = styled(Button)`
  flex: 0;
  margin-left: 12px;
  text-align: right;
`

export const Description = styled.div`
  display: flex;
  flex-direction: row;
`

export const FormWrapper = styled.div`
  margin-top: 32px;
`

export const FormActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
`
